<template>
  <div class="login-dialog">
    <el-dialog
      :visible.sync="visible"
      width="550px"
      :close-on-click-modal="false"
      :show-close="true"
      :lock-scroll="false"
      center>
      <!-- 头部 -->
      <div class="login-header">
        <h2 v-if="mode === 'login'">渔链门户 · 用户登录</h2>
        <h2 v-else>渔链门户 · 用户注册</h2>
        <p>欢迎使用渔链门户平台</p>
      </div>

      <!-- 登录 表单 -->
      <div
        v-if="mode === 'login'"
        style="display: flex; justify-content: center; align-items: center">
        <el-form
          ref="loginForm"
          :model="loginForm"
          :rules="loginRules"
          class="login-form"
          auto-complete="off">
          <div>
            <el-form-item prop="username">
              <el-input
                v-model="loginForm.username"
                name="username"
                placeholder="请输入手机号"
                auto-complete="off"
                prefix-icon="el-icon-user" />
            </el-form-item>
          </div>

          <!-- 密码 -->
          <div>
            <el-form-item prop="password">
              <el-input
                :type="pwdType"
                v-model="loginForm.password"
                name="password"
                auto-complete="off"
                placeholder="请输入密码"
                prefix-icon="el-icon-lock"
                show-password>
                <i slot="suffix" class="el-input__icon" @click="showPwd" />
              </el-input>
            </el-form-item>
          </div>

          <!-- 验证码 -->
          <el-form-item prop="code">
            <div style="display: flex; justify-content: center; align-items: center">
              <div style="display: flex; gap: 10px; align-items: center; margin-right: 10px">
                <el-input
                  clearable
                  v-model="loginForm.code"
                  name="code"
                  auto-complete="off"
                  placeholder="请输入验证码"
                  @keyup.enter.native="handleLogin" />
              </div>
              <div
                style="
                  width: 80px;
                  height: 35px;
                  cursor: pointer;
                  border: 1px solid #dcdfe6;
                  border-radius: 4px;
                  transition: all 0.3s;
                ">
                <img
                  style="width: 100%; height: 100%; margin: 0 !important"
                  @click="getVerify"
                  :src="pic_url"
                  alt="" />
              </div>
            </div>
          </el-form-item>

          <el-button type="primary" :loading="loading" class="login-btn" @click="handleLogin">
            登录
          </el-button>

          <!-- 辅助 -->
          <div class="login-extra">
            <span @click="goRegister">注册账号</span>
            <!-- <span @click="showBoxVisible = true">忘记密码？</span> -->
          </div>
        </el-form>
      </div>
    </el-dialog>

    <!-- 忘记密码弹窗 -->
    <div class="showbox">
      <el-dialog
        title="忘记密码"
        :visible.sync="showBoxVisible"
        width="500px"
        @close="handleCancel"
        :lock-scroll="false">
        <el-form
          :model="ruleFormForget"
          status-icon
          :rules="rulesForget"
          ref="ruleFormForget"
          label-width="110px"
          class="demo-ruleForm"
          label-position="left">
          <el-form-item label="手机号码：" prop="mobile">
            <el-col :span="15">
              <el-input
                type="text"
                clearable
                v-model="ruleFormForget.mobile"
                autocomplete="off"
                max="11"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="图形验证码：">
            <el-col :span="15">
              <el-input
                type="text"
                clearable
                v-model="ruleFormForget.verify"
                autocomplete="off"></el-input>
            </el-col>
            <el-col :span="8" :offset="1" align="right" style="height: 34px">
              <el-image
                style="width: 100%; height: 38px"
                :src="pic_url"
                fit="cover"
                @click="getVerify">
                <div slot="error" class="image-slot-error" style="line-height: 32px">暂无图片</div>
              </el-image>
            </el-col>
          </el-form-item>
          <el-form-item label="验证码：" prop="code">
            <el-row justify="space-between">
              <el-col :span="15">
                <el-input
                  type="text"
                  clearable
                  v-model.number="ruleFormForget.code"
                  autocomplete="off"></el-input>
              </el-col>
              <el-col :span="8" :offset="1" align="right">
                <el-button
                  style="width: 100%"
                  @click="sendCode"
                  :disabled="isSend"
                  :plain="isSend"
                  class="sendCode">
                  {{ sendTxt }}
                </el-button>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="重置密码" prop="password">
            <el-input
              type="password"
              clearable
              v-model="ruleFormForget.password"
              :min="6"
              autocomplete="new-password"
              placeholder="密码长度6~16位，同时包含数字，字母"></el-input>
          </el-form-item>
          <el-form-item label-width="0">
            <div style="width: 100%; text-align: center">
              <el-button type="primary" @click="handleCancel" plain>取消</el-button>
              <el-button type="primary" @click="submitForm">重置</el-button>
            </div>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { captchaCode, forgetPassword, sendCode } from '@/api/login'
import { getVerify } from '@/api/public'
import { getVerifyCode, sendSmsCode } from '@/api/register'
import { isPassword0 } from '@/utils/validate'

export default {
  name: 'LoginDialog',

  computed: {
    visible: {
      get() {
        return this.$store.state.authModal.visible
      },
      set(val) {
        if (!val) {
          this.$store.dispatch('authModal/closeModal')
        }
      }
    },
    mode() {
      return this.$store.state.authModal.mode || 'login'
    }
  },

  data() {
    // 验证规则
    var ruleTelphone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('手机号不能为空'))
      } else if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error('手机号输入有误'))
      } else {
        callback()
      }
    }
    var ruleCode = (rule, value, callback) => {
      if (!String(value)) {
        callback(new Error('验证码不能为空'))
      } else if (String(value).length != 4) {
        callback(new Error('请输入4位数验证码'))
      } else {
        callback()
      }
    }
    var rulePassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('密码不能为空'))
      } else if (!isPassword0(String(value))) {
        callback(new Error('请输入6-18位的数字或字母'))
      } else {
        callback()
      }
    }

    return {
      // 登录
      loginForm: {
        username: '',
        password: '',
        code: ''
      },

      loginRules: {
        username: [{ required: true, message: '手机号不得为空', trigger: 'blur' }],
        password: [{ required: true, message: '密码不得为空', trigger: 'blur' }],
        code: [{ required: true, message: '验证码不得为空', trigger: 'blur' }]
      },

      loading: false,
      pwdType: 'password',
      redirect: undefined,

      // ===========忘记密码表单===========
      // captcha: {},
      // 弹窗
      showBoxVisible: false,
      isSend: false,
      sendTxt: '发送验证码',
      ruleFormForget: {
        mobile: '',
        verify: '',
        code: '',
        password: ''
      },
      rulesForget: {
        mobile: [{ validator: ruleTelphone, trigger: 'blur' }],
        code: [{ validator: ruleCode, trigger: 'blur' }],
        password: [{ validator: rulePassword, trigger: 'blur' }]
      },

      // 图片验证码
      captcha: captchaCode,
      t: new Date().getTime(),
      pic_url: ''
    }
  },

  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    },

    // 监听弹窗状态变化
    visible(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.resetForms()
      }
    }
  },

  created() {
    // this.getCaptcha()
    this.getVerify()
  },

  methods: {
    getVerify() {
      getVerifyCode().then(res => {
        // console.log('验证码接口返回：', res)
        if (res.resultCode == 1) {
          // this.pic_url = res.resultInfo

          // 统一图片返回格式
          let img = res.resultInfo

          if (!img.startsWith('data:image')) {
            img = 'data:image/png;base64,' + img
          } else {
            img = img.replace(/data:image\/.*?;base64/, 'data:image/png;base64')
          }

          this.pic_url = img
        }
      })
    },

    // 获取图片验证码
    getCaptcha() {
      this.t = new Date().getTime()
    },

    showPwd() {
      this.pwdType = this.pwdType === 'password' ? '' : 'password'
    },

    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true

          this.$store
            .dispatch('user/login', this.loginForm)
            .then(() => {
              // console.log('登录完成')
              // console.log('用户信息:', this.$store.getters.userInfo)
              // console.log('isLogin:', this.$store.getters.isLogin)
              // console.log('name:', this.$store.getters.name)

              this.loading = false
              this.$message.success('登录成功')

              // 关闭 modal
              this.$store.dispatch('authModal/closeModal')
              // 如果有 returnTo，跳转回去（例如详情页）
              const r = this.$store.state.authModal.returnTo
              if (r) this.$router.push(r)
              this.$emit('success')
            })
            .catch(err => {
              console.error('登录失败:', err)
              this.loading = false
              this.getVerify() // 刷新验证码
            })
        } else {
          this.getVerify()
          console.log('error submit!!')
          return false
        }
      })
    },

    // 忘记密码提交数据
    submitForm(formName) {
      this.$refs.ruleFormForget.validate(valid => {
        if (valid) {
          forgetPassword(this.ruleFormForget)
            .then(res => {
              if (res.resultCode == 1) {
                this.$message({ message: '密码重置成功！', type: 'success' })
                this.handleCancel()
                this.isSend = false
                this.sendTxt = '发送验证码'
              }
            })
            .catch()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    // 忘记密码发送验证码
    sendCode() {
      if (!this.ruleFormForget.mobile) {
        this.$message({ message: '手机号不能为空', type: 'warning' })
      } else if (!/^1[3456789]\d{9}$/.test(this.ruleFormForget.mobile)) {
        this.$message({ message: '手机号输入有误', type: 'warning' })
      } else if (!this.ruleFormForget.verify) {
        this.$message({ message: '请输入图片验证码', type: 'warning' })
      } else {
        var that = this
        sendSmsCode({ mobile: this.ruleFormForget.mobile, code: this.ruleFormForget.verify })
          .then(res => {
            if (res.resultCode == 1) {
              that.isSend = true
              var time = 60
              var t = setInterval(function () {
                if (time > 0) {
                  that.sendTxt = time + 's'
                  time--
                } else {
                  that.isSend = false
                  that.sendTxt = '发送验证码'
                  clearInterval(t)
                }
              }, 1000)
            }
          })
          .catch()
      }
    },

    // 取消显示弹窗
    handleCancel() {
      // 提交的表单置空
      this.ruleFormForget.mobile = ''
      this.ruleFormForget.verify = ''
      this.ruleFormForget.code = ''
      this.ruleFormForget.password = ''
      this.showBoxVisible = false //隐藏弹窗
      // this.getCaptcha()
      this.getVerify()
      this.$nextTick(() => {
        this.$refs.ruleFormForget.clearValidate() //重置弹窗内容
      })
    },

    goRegister() {
      this.$store.dispatch('authModal/closeModal')
      this.$router.push('/register')
      // 切换到注册模式并保持 modal 打开
      // this.$store.dispatch('authModal/openModal', {
      //   mode: 'register',
      //   returnTo: this.$store.state.authModal.returnTo,
      // })
    },

    resetForms() {
      // 重置登录表单
      this.loginForm = {
        username: '',
        password: '',
        code: ''
      }

      // 重置忘记密码表单
      this.ruleFormForget = {
        mobile: '',
        verify: '',
        code: '',
        password: ''
      }

      // 清除表单验证状态
      this.$nextTick(() => {
        if (this.$refs.loginForm) {
          this.$refs.loginForm.clearValidate()
        }

        if (this.$refs.ruleFormForget) {
          this.$refs.ruleFormForget.clearValidate()
        }
      })

      // 刷新验证码
      this.getVerify()
    }
  }
}
</script>

<style scoped lang="scss">
.login-dialog {
  :deep(.el-dialog) {
    border-radius: 15px;
  }

  :deep(.el-dialog__header) {
    padding: 0;
  }

  .login-header {
    text-align: center;
    margin-bottom: 25px;

    h2 {
      margin: 0;
      font-size: 28px;
      font-weight: 600;
    }

    p {
      margin-top: 6px;
      font-size: 18px;
      color: #909399;
    }
  }

  .login-btn {
    width: 100%;
    margin-top: 5px;
    font-size: 22px;
  }

  .login-extra {
    display: flex;
    // justify-content: space-between;
    justify-content: center;

    margin-top: 15px;
    font-size: 18px;

    span {
      color: #409eff;
      cursor: pointer;
    }
  }

  // 忘记密码弹窗
  .showbox {
    :deep(.el-dialog__header) {
      padding: 15px;
    }

    :deep(.el-dialog__body) {
      padding: 15px 30px 10px;
    }
  }
}
</style>
